export const state = {
  products: [],
  systemProduct: [],
  singleproducts: []
};
export default state;



// WEBPACK FOOTER //
// ./src/vuex/modules/products/state.js